import GetValueModule from './GetValueModule';

export default GetValueModule;
